import Vue from 'vue';
import App from './App.vue';

import axios from 'axios';
axios.defaults.baseURL = '/api'
Vue.prototype.$axios = axios;

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import { Message } from 'element-ui';
Vue.prototype.$message = Message

// 引入echarts
import * as echarts from 'echarts';
import 'echarts/theme/shine.js';
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false

new Vue({
    axios,
    render: h => h(App),
}).$mount('#app')
